import {
  Color,
  Button as ButtonV2,
  Flex,
  Icon,
  Text,
  Title,
} from '@bb/elements-web';
import { Button, message, Modal } from 'components';
import { AuthContext } from 'contexts';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { formatPhoneNumber } from 'utils';
import CoopSelectContext from '../CoopSelectContext';
import Notes from './Notes';
import ShowingTypeSelector from './ShowingTypeSelector';
import deleteCustomAgent from '../../../../../../api/CustomAgentController/delete';

const CustomAgentDetails: React.FC = () => {
  const { auth } = useContext(AuthContext);
  const { setBookFor, coop, setCoop, coopAdditionalData } =
    useContext(CoopSelectContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  if (
    !coop ||
    !coopAdditionalData ||
    coopAdditionalData.coopType !== 'customAgent'
  )
    return null;

  const showEditButtons = coopAdditionalData.createdBy === auth.id;

  const handleDelete = async () => {
    await deleteCustomAgent(coop.id!);
    message.success('Custom agent deleted');
    setIsModalOpen(false);
    setCoop(null);
  };

  return (
    <StyledFlex vertical gap="small">
      <div>
        <Text thickness="bold">Name: </Text>
        <Text>
          {coop.firstName!.toUpperCase()} {coop.lastName!.toUpperCase()}
        </Text>
      </div>
      <div>
        <Text size="large">{coopAdditionalData.orgName.toUpperCase()}</Text>
        {coopAdditionalData.orgAddress && (
          <>
            <br />
            <Text>{coopAdditionalData.orgAddress.toUpperCase()}</Text>
          </>
        )}
      </div>
      <div>
        <Text thickness="bold">Office: </Text>
        <Text>{formatPhoneNumber(coopAdditionalData.orgPhone)}</Text>
        <br />
        <Text thickness="bold">Mobile: </Text>
        <Text>{formatPhoneNumber(coop.phone)}</Text>
        <br />
        <Text thickness="bold">Email: </Text>
        <Text>{coop.email}</Text>
      </div>
      <Text>Listing agent to confirm approval for this contact</Text>
      <ShowingTypeSelector />
      <Notes />
      {showEditButtons && (
        <Flex justify="space-around">
          <Button
            size="small"
            type="primary"
            data-cy="editCustomAgent-btn"
            onClick={() => setBookFor('customAgentCreate')}
          >
            Edit Profile
          </Button>
          <Button
            size="small"
            type="primary"
            danger
            data-cy="deleteCustomAgent-btn"
            onClick={() => setIsModalOpen(true)}
          >
            Delete Profile
          </Button>
        </Flex>
      )}
      <Modal
        title={
          <Flex gap="middle" align="center">
            <Icon icon="warningOutlined" size={24} color="warning" />
            <Title level={3} dataCy="deleteCustomAgentModal-title">
              Delete Custom Agent
            </Title>
          </Flex>
        }
        footer={
          <Flex justify="space-around">
            <ButtonV2
              dataCy="cancelCustomAgentDelete-btn"
              type="secondary"
              onClick={() => setIsModalOpen(false)}
            >
              Cancel
            </ButtonV2>{' '}
            <StyledDeleteButton
              dataCy="yesCustomAgentDelete-btn"
              onClick={handleDelete}
            >
              Yes
            </StyledDeleteButton>
          </Flex>
        }
        centered
        closable={false}
        open={isModalOpen}
        data-cy="customAgent-delete-modal"
      >
        <Text style={{ textAlign: 'center' }} size="large">
          Are you sure you want to delete this custom agent? This operation is
          permanent and cannot be undone.
        </Text>
      </Modal>
    </StyledFlex>
  );
};

const StyledFlex = styled(Flex)`
  padding: 15px 0;
`;

const StyledDeleteButton = styled(ButtonV2)`
  background: ${Color.JANEMBA};
`;

export default CustomAgentDetails;
